import { HttpInterceptorFn, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const toastr = inject(ToastrService);

  const token = localStorage.getItem('token');

  // Skip token & error handling for login API
  const isLoginRequest = req.url.includes('/login');  

  if (token && !isLoginRequest) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req).pipe(
    catchError((err: any) => {

      // Show expired toast only for secured APIs
      if (err.status === 401 && !isLoginRequest) {
        toastr.error('Login expired. Please login again.');
        localStorage.removeItem('token');
        router.navigate(['/login']);
      }

      return throwError(() => err);
    })
  );
};